import type { StatusVariant } from "../components/table/StyledTable";

/**
 * Maps a case status onto a status-pill variant so every table in the
 * app colours the same status identically.
 *
 * - success: the case reached a good terminal state
 * - error:   the case ended badly or escalated
 * - warning: we are blocked on someone else
 * - info:    actively being worked on
 * - default: nothing has happened yet
 */
const STATUS_VARIANTS: Record<string, StatusVariant> = {
  OFFEN: "default",
  WARTE_AUF_NUTZERANGABEN: "warning",
  WARTE: "warning",
  ZAHLUNGSAUFFORDERUNG: "warning",
  BEARBEITUNG_UNS: "info",
  MAHNUNG: "error",
  WIDERRUFEN: "error",
  GERICHT: "error",
  INKASSO: "error",
  ABGESCHLOSSEN: "success",
};

export const getStatusVariant = (status?: string | null): StatusVariant =>
  (status && STATUS_VARIANTS[status]) || "default";
